import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { CustomerOrganizationCompartments, customerOrganizationStorageKey } from '..';

export class CustomerOrganizationListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.OrganizationSelected) private readonly predicate: Observable<boolean>,
    @injectDataCache(customerOrganizationStorageKey)
    private readonly cache: DataCache<CustomerOrganizationCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('customerOrganization');
        } else {
          this.cache.reset('customerOrganization');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
